'use client'

import { FEATURE_FLAGS, FeatureFlagRoute } from '@scalis/feature-flags'
import { Aside } from '../aside'
import { ATS } from './ats'
import { JobRequisitions } from './components'
import { CRM } from './crm'

export const DefaultSidebar = () => {
  return (
    <Aside.Container
      collapsible
      collapsed
      persistCollapsed
    >
      {({ showContent, expand }) => {
        return (
          <>
            <FeatureFlagRoute
              featureFlag={FEATURE_FLAGS.CRM}
              redirect={false}
            >
              <CRM showContent={showContent} />
            </FeatureFlagRoute>
            <ATS showContent={showContent} />
            <div className='overflow-y-auto'>
              <JobRequisitions
                showContent={showContent}
                expand={expand}
              />
            </div>
          </>
        )
      }}
    </Aside.Container>
  )
}
